// Simba Travel official logo asset.
const LOGO_URL = "/brand/simba-travel-logo.png";

export default function SimbaLogo({ className = "", variant = "default" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Simba Travel"
      className={className}
      data-testid="simba-logo"
      loading="eager"
    />
  );
}
